import type { IPathBaseParam } from "./path";
import type { IUserDeleteRequestsDto } from "./types";

import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  IUserDeleteRequestsDto
>("users.me.deleteRequests");

export const deleteRequests = {
  ...postApis,
};
